import React from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { BottomNav } from './BottomNav';
import { CustomerServiceFab } from '@/components/CustomerServiceFab';
import styles from './Layout.module.less';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isHomePage = useLocation().pathname === '/';

  return (
    <div className={`${styles.layout} ${isHomePage ? styles.layoutHome : ''}`}>
      <Header />
      <main className={styles.main}>{children}</main>
      <Footer />
      <BottomNav />
      <CustomerServiceFab />
    </div>
  );
};

